import { DEBUG, PATH } from '../constants';

const base = PATH;
const debug = DEBUG;

/**
 * Récupère toutes les progressions "Inde" d’un utilisateur
 */
export async function getProgressIndeByUser(userId) {
    try {
        const response = await fetch(`${base}progress-inde/user/${userId}`);
        return await response.json();
    } catch (error) {
        console.error('Erreur getProgressIndeByUser', error);
        throw error;
    }
}

/**
 * Récupère toutes les progressions d’un utilisateur
 */
export async function getLastsProgressionsIndeByUser(userId) {
    try {
        const response = await fetch(`${base}progress-inde/user/lasts/${userId}`);
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur getProgressionsByUser', error);
        throw error;
    }
}

/**
 * Récupère toutes les progressions d’un jeu (Inde)
 */
export async function getProgressIndeByGame(gameInfosId) {
    try {
        const response = await fetch(`${base}progress-inde/game/${gameInfosId}`);
        return await response.json();
    } catch (error) {
        console.error('Erreur getProgressIndeByGame', error);
        throw error;
    }
}

/**
 * Récupère la dernière progression d’un utilisateur sur un jeu
 */
export async function getLastProgressInde(userId, gameInfosId) {
    try {
        const response = await fetch(`${base}progress-inde/${userId}/${gameInfosId}`);
        return await response.json();
    } catch (error) {
        console.error('Erreur getLastProgressInde', error);
        throw error;
    }
}

/**
 * Crée une nouvelle progression "Inde"
 */
export async function createProgressInde(userId, gameInfosId, nbPlayers = 1, achievedAt = null) {
    try {
        const response = await fetch(`${base}progress-inde/insert`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id_utilisateur: userId,
                id_game_infos: gameInfosId,
                nb_players: nbPlayers,
                achieved_at: achievedAt
            })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur createProgressInde', error);
        throw error;
    }
}

/**
 * Marque une progression "Inde" comme terminée
 */
export async function achieveProgression(progressionId, userId, gameInfosId) {
    try {
        const response = await fetch(`${base}progress-inde/finish`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: progressionId,
                id_utilisateur: userId,
                id_game_infos: gameInfosId
            })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur finishProgressInde', error);
        throw error;
    }
}


/**
 * Met à jour la progression "Inde" avec la question courante
 */
export async function updateProgressionInde(progressionId, userId, gameInfosId, questionId) {
    try {
        const response = await fetch(`${base}progress-inde/update`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: progressionId,
                id_utilisateur: userId,
                id_game_infos: gameInfosId,
                id_question: questionId
            })
        });

        return await response.json();
    } catch (error) {
        console.error('Erreur finishProgressInde', error);
        throw error;
    }
}


export async function getStatsForGame(idGame, start, end) {
    const token = localStorage.getItem('authToken');
    try {
        const response = await fetch(`${base}progress-inde/game-stats/${idGame}?start=${start}&end=${end}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Erreur ${response.status} : ${response.statusText}`);
        }

        return await response.json(); // { sessions: ..., estimated_players: ... }
    } catch (error) {
        if (debug) console.error('Erreur getStatsForGame', error);
        throw error;
    }
}

export async function getAllGamesStats(start, end) {
    const token = localStorage.getItem('authToken');
    try {
        const response = await fetch(`${base}progress-inde/all-games-stats?start=${start}&end=${end}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Erreur ${response.status} : ${response.statusText}`);
        }

        return await response.json(); // { sessions: ..., estimated_players: ... }
    } catch (error) {
        if (debug) console.error('Erreur getAllGamesStats', error);
        throw error;
    }
}

export async function getFinishedRuns(idGame, page = 1, limit = 10) {
    const token = localStorage.getItem('authToken');
    try {
        const response = await fetch(`${base}progress-inde/finished-runs/${idGame}?page=${page}&limit=${limit}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Erreur ${response.status} : ${response.statusText}`);
        }

        return await response.json(); // { page: ..., limit: ..., results: [...] }
    } catch (error) {
        if (debug) console.error('Erreur getFinishedRuns', error);
        throw error;
    }
}
